const s = {
  name: "FaceIdApple",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,7c0-2.8,2.2-5,5-5h5V0H7C3.1,0,0,3.1,0,7v5h2V7z"/>
		<path class="st0" d="M28,2h5c2.8,0,5,2.2,5,5v5h2V7c0-3.9-3.1-7-7-7h-5V2z"/>
		<path class="st0" d="M38,33v-5h2v5c0,3.9-3.1,7-7,7h-5v-2h5C35.8,38,38,35.8,38,33z"/>
		<path class="st0" d="M2,33v-5H0v5c0,3.9,3.1,7,7,7h5v-2H7C4.2,38,2,35.8,2,33z"/>
		<path class="st0" d="M20,20v-7h2v7c0,2.8-2.2,5-5,5v-2C18.7,23,20,21.7,20,20z"/>
		<path class="st0" d="M11,13v5h2v-5H11z"/>
		<path class="st0" d="M27,18v-5h2v5H27z"/>
		<path class="st0" d="M20,30c-2.8,0-5.3-1.1-7.1-2.9l-1.4,1.4c2.2,2.2,5.2,3.5,8.5,3.5s6.3-1.3,8.5-3.5l-1.4-1.4
			C25.3,28.9,22.8,30,20,30z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FaceIdApple
};
